<app-navbar title="Wydarzenia">
	<a routerLink="./add" class="btn btn-danger"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-tourism-events-filters
	userFilters="tourismEvents"
	[statuses]="parameters.statuses"
	[forceFilters]="{ datesBriefing: 1 }"
	[yesno]="parameters.yesno"
	[vehicle_busTypes]="parameters.vehicle_busType"
	[vehicle_statuses]="parameters.vehicle_status"
	[categories]="parameters.category"
	[users]="parameters.users"
	(selected)="filtersSelected($event)"
></app-tourism-events-filters>

<app-dynamic-table-v2
	[module]="'tourism-events'"
	[elements]="data"
	[columns]="tableRows"
	[pageSizeOptions]="pageSizeOptions"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table-v2>
